"use strict";
var ajaxUtils_1 = require("../utils/ajaxUtils");
var PlacementsUtils = (function () {
    function PlacementsUtils() {
    }
    /**
     * Получить споносорский контент для указанного места размещения
     * @param url Ссылка на метод API 2
     * @param onSuccess Обработчик успешного вызова
     */
    PlacementsUtils.getPlacements = function (url, onSuccess) {
        return ajaxUtils_1.AjaxUtils.apiV2Get("placements" + url)
            .done(function (result) {
            if (result.status !== "Success" || !result.data || !result.data.items || !result.data.items.length) {
                return $.Deferred().reject();
            }
            try {
                var arr = [];
                for (var i = 0; i < result.data.items.length; i++) {
                    var item = result.data.items[i];
                    var contentId = item.id;
                    for (var j = 0; j < item.works.length; j++) {
                        var work = item.works[j];
                        work.contentId = contentId;
                        work.viewUrl = app.rootUrl + "go/placement?workId=" + work.id + "&id=" + contentId;
                        work.viewSeriesUrl = "";
                        if (work.seriesId) {
                            work.viewSeriesUrl = app.rootUrl + "go/placement?seriesId=" + work.seriesId + "&id=" + contentId;
                        }
                        work.viewReviewsUrl = "";
                        if (work.reviewCount) {
                            work.viewReviewsUrl = app.rootUrl + "go/placement?reviewsId=" + work.id + "&id=" + contentId;
                        }
                        for (var a = 0; a < work.authors.length; a++) {
                            work.authors[a].viewUrl = app.rootUrl + "go/placement?authorId=" + work.authors[a].id + "&id=" + contentId;
                        }
                        arr.push(work);
                    }
                }
                onSuccess(arr);
                return $.Deferred().resolve();
            }
            catch (e) {
                console.log(e);
                return $.Deferred().reject();
            }
        });
    };
    /**
     * Скрыть споносорский контент
     * @param onSuccess Обработчик успешного вызова
     */
    PlacementsUtils.hidePlacements = function (placementId, onSuccess) {
        if (placementId === void 0) { placementId = null; }
        if (onSuccess === void 0) { onSuccess = null; }
        return ajaxUtils_1.AjaxUtils.apiV2Post("placements/hide?id=" + placementId)
            .done(function (result) {
            if (result.status !== "Success") {
                return $.Deferred().reject();
            }
            try {
                if (onSuccess)
                    onSuccess(result.data);
                return $.Deferred().resolve();
            }
            catch (e) {
                console.log(e);
                return $.Deferred().reject();
            }
        });
    };
    /**
     * Отправить событие добавления в корзину (нажатие на кнопку Купить)
     * @param id Идентификатор произведения
     */
    PlacementsUtils.trackClickBuy = function (id) {
        return ajaxUtils_1.AjaxUtils.apiV2Post("placements/track?e=buy&d=" + id);
    };
    /**
     * Отправка трекинга просмотра
     */
    PlacementsUtils.startViewStatsCollector = function () {
        try {
            var $placements = $(".placement");
            var observerElements = $placements.toArray();
            // Создаем новый observer (наблюдатель)
            var observer_1 = new window["IntersectionObserver"](function (entries) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        setTimeout(function () {
                            var placementNode = entry.target;
                            if (observerElements.indexOf(placementNode) >= 0 &&
                                entry.target.getBoundingClientRect().bottom > 0 &&
                                entry.target.getBoundingClientRect().top < document.documentElement.clientHeight) {
                                observerElements = observerElements.filter(function (elem) { return elem !== placementNode; });
                                var id = $(placementNode).attr("data-id");
                                if (id) {
                                    ajaxUtils_1.AjaxUtils.apiV2Post("placements/track?e=content-view&d=" + id);
                                }
                            }
                        }, 100);
                    }
                });
            });
            $placements.each(function (index, el) {
                observer_1.observe(el);
            });
        }
        catch (e) {
            console.error(e);
        }
    };
    return PlacementsUtils;
}());
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = PlacementsUtils;
//# sourceMappingURL=placementsUtils.js.map